import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { messageCenterApi } from '@/modules/foundation/api/messageCenter';
import type { AnnouncementInfo } from '@/modules/foundation/api/types';

/**
 * 常驻横幅：「每日首次弹窗，之后仅横幅」的公告在失效前一直显示在页面顶部。
 * 关闭只对当前页面有效，刷新后重新出现。
 */
const AnnouncementBanner: React.FC = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState<AnnouncementInfo[]>([]);
  const [closed, setClosed] = useState<Set<number>>(new Set());

  const load = useCallback(async () => {
    try {
      const response = await messageCenterApi.getAnnouncementBanners();
      setItems(response.list || []);
    } catch {
      setItems([]);
    }
  }, []);

  useEffect(() => {
    void load();
    const timer = window.setInterval(() => { void load(); }, 60_000);
    return () => window.clearInterval(timer);
  }, [load]);

  const visible = items.filter((item) => !closed.has(item.id));
  if (visible.length === 0) return null;

  return (
    <div style={{ marginBottom: 12 }}>
      {visible.map((item) => (
        <Alert
          key={item.id}
          banner
          showIcon
          closable
          type={item.level === 'urgent' ? 'error' : 'warning'}
          message={item.title}
          action={<Button size="small" type="link" onClick={() => navigate('/tenant/message-center', { state: { announcementId: item.id } })}>查看详情</Button>}
          onClose={() => setClosed((current) => new Set(current).add(item.id))}
        />
      ))}
    </div>
  );
};

export default AnnouncementBanner;
